<template>
  <BoardContactChannel />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center',
  middleware: [
    'naver-ads',
    'kakao-pixel'
  ]
})

const { ogUrl, ogTitle, keyword } = useSeo()

useSeoMeta({
  title: '문의하기',
  description: '유심사의 eSIM, USIM 서비스가 궁금하세요? 궁금하신 질문을 카카오톡으로 빠르게 답변해 드릴게요.',
  ogType: 'website',
  ogUrl: () => ogUrl('board/contact-channel'),
  ogTitle: () => ogTitle('문의하기'),
  ogDescription: '유심사의 eSIM, USIM 서비스가 궁금하세요? 궁금하신 질문을 카카오톡으로 빠르게 답변해 드릴게요.',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('문의하기'),
  twitterDescription: '유심사의 eSIM, USIM 서비스가 궁금하세요? 궁금하신 질문을 카카오톡으로 빠르게 답변해 드릴게요.',
  keywords: keyword('문의하기, eSIM문의하기, 이심문의하기, USIM문의하기, 유심문의하기')
})

</script>
